"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ReceivableSchema = void 0;
const transport_types_1 = require("@alliance-disposal/transport-types");
const meta_data_invoice_1 = require("../base/meta-data-invoice");
/**
 * Search schema for v2 receivables. Customer array fields (contacts, service locations) use flat
 * matching — a receivable matches if any item matches.
 */
exports.ReceivableSchema = {
    name: 'receivable',
    alias: 'Receivable',
    shortName: 'Invoice',
    applications: ['aap', 'wayste'],
    returnType: {
        aap: transport_types_1.InvoiceV2.ReceivableTransport,
        wayste: transport_types_1.InvoiceV2.ReceivableTransport,
    },
    searchableAttributes: [
        {
            field: 'invoiceDetails.invoiceNumber',
            alias: 'Invoice Number',
            shortName: 'invoiceNumber',
            searchableByDefault: true,
        },
        {
            field: 'invoiceDetails.memo',
            alias: 'Memo',
            shortName: 'memo',
            searchableByDefault: true,
        },
        {
            field: 'customer.companyName',
            alias: 'Company',
            shortName: 'Company',
            searchableByDefault: true,
        },
        {
            field: 'customer.displayName',
            alias: 'Customer Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'customer.contacts.firstName',
            alias: 'Contact Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'customer.contacts.lastName',
            alias: 'Contact Name',
            shortName: 'Name',
            searchableByDefault: true,
        },
        {
            field: 'customer.customerNumber',
            alias: 'Account Number',
            shortName: 'Account Number',
            searchableByDefault: false,
        },
        {
            field: 'customer.billingAddress.addressLine1',
            alias: 'Billing Address',
            shortName: 'Address',
            searchableByDefault: true,
        },
        {
            field: 'customer.billingAddress.city',
            alias: 'Billing City',
            shortName: 'City',
            searchableByDefault: true,
        },
        {
            field: 'customer.billingAddress.state',
            alias: 'Billing State',
            shortName: 'State',
            searchableByDefault: false,
        },
        {
            field: 'customer.billingAddress.zip',
            alias: 'Billing Zip Code',
            shortName: 'Zip',
            searchableByDefault: false,
        },
        {
            field: 'subscriptions.orders.serviceLocation.address.addressLine1',
            alias: 'Service Address',
            shortName: 'Service Address',
            searchableByDefault: true,
        },
        {
            field: 'subscriptions.orders.serviceLocation.address.city',
            alias: 'Service City',
            shortName: 'Service City',
            searchableByDefault: true,
        },
        {
            field: 'subscriptions.number',
            alias: 'Order Number',
            shortName: 'Order Number',
            searchableByDefault: true,
        },
        {
            field: 'subscriptions.poNumber',
            alias: 'PO Number',
            shortName: 'PO',
            searchableByDefault: true,
        },
        {
            field: 'subscriptions.soNumber',
            alias: 'SO Number',
            shortName: 'SO',
            searchableByDefault: true,
        },
        {
            field: 'commercialSubscriptions.subscriptionNumber',
            alias: 'Order Number',
            shortName: 'Order Number',
            searchableByDefault: true,
        },
        {
            field: 'commercialSubscriptions.poNumber',
            alias: 'PO Number',
            shortName: 'PO',
            searchableByDefault: true,
        },
        {
            field: 'commercialSubscriptions.serviceLocation.address.addressLine1',
            alias: 'Service Address',
            shortName: 'Service Address',
            searchableByDefault: true,
        },
        {
            field: 'commercialSubscriptions.serviceLocation.address.city',
            alias: 'Service City',
            shortName: 'Service City',
            searchableByDefault: true,
        },
    ],
    filterableAttributes: [
        {
            type: 'STRING',
            field: 'invoiceDetails.status',
            alias: 'Invoice Status',
            shortName: 'Status',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: transport_types_1.InvoiceV2.InvoiceStatuses.map((status) => ({
                value: status,
                label: transport_types_1.InvoiceV2.InvoiceStatusLabels[status],
            })),
        },
        {
            type: 'NUMBER',
            field: 'invoiceDetails.term',
            alias: 'Term',
            shortName: 'Term',
            allowedOperators: 'ALL',
            format: 'INTEGER',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.issueDate',
            alias: 'Issue Date',
            shortName: 'Issue Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.dueDate',
            alias: 'Due Date',
            shortName: 'Due Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.payments.date',
            alias: 'Payment Date',
            shortName: 'Payment Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'TIMESTAMP',
            field: 'invoiceDetails.refunds.date',
            alias: 'Refund Date',
            shortName: 'Refund Date',
            allowedOperators: 'ALL',
            format: 'ISO',
        },
        {
            type: 'STRING',
            field: 'subscriptions.status',
            alias: 'Service Status',
            shortName: 'Service Status',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: transport_types_1.Operations.Enums.OperationsSubscriptionStatuses.map((status) => ({
                value: status,
                label: transport_types_1.Operations.Enums.OperationsSubscriptionStatusLabels[status].wayste,
            })),
        },
        {
            type: 'STRING',
            field: 'subscriptions.subscriptionType',
            alias: 'Order Type',
            shortName: 'Order Type',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: [
                { value: 'ORDER_PT_LOO', label: 'Portable Toilet' },
                { value: 'ORDER_RO', label: 'Roll-Off' },
                { value: 'ORDER_COMMERCIAL', label: 'Commercial' },
            ],
        },
        {
            type: 'STRING',
            field: 'subscriptions.orders.orderRo.status',
            alias: 'Order Status',
            shortName: 'Order Status',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: transport_types_1.Operations.Enums.OrderRoStatuses.map((status) => ({
                value: status,
                label: transport_types_1.Operations.Enums.OrderRoStatusLabels[status].wayste,
            })),
        },
        {
            type: 'STRING',
            field: 'commercialSubscriptions.status',
            alias: 'Commercial Status',
            shortName: 'Commercial Status',
            allowedOperators: 'ALL',
            allowsMultipleValues: true,
            options: transport_types_1.Commercial.Enums.CommercialSubscriptionStatuses.map((status) => ({
                value: status,
                label: transport_types_1.Commercial.Enums.CommercialSubscriptionStatusLabels[status].wayste,
            })),
        },
        ...meta_data_invoice_1.MetaDataFiltersInvoice,
    ],
    extraMappings: [
        {
            field: 'haulerID',
            elasticMapping: {
                type: 'text',
                fields: {
                    keyword: {
                        type: 'keyword',
                        ignore_above: 256,
                    },
                },
            },
        },
    ],
    // Drop customer sub-collections we don't search, to keep the document small. Contacts and service
    // locations stay — they hold search fields.
    dropFields: [{ field: 'customer.documents' }, { field: 'customer.files' }],
};
//# sourceMappingURL=receivable.js.map